export function ConnectWithUs() {
  return (
    <section className="py-8 bg-gray-50">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Section Title */}
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-600 mb-6">Connect With Us</h2>
        </div>

        {/* Social Media Icons */}
        <div className="flex justify-center gap-4">
          <a
            href="https://www.facebook.com/100212768536512"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-12 h-12 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors"
            aria-label="Follow us on Facebook"
          >
            <svg
              className="w-6 h-6"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                clipRule="evenodd"
              />
            </svg>
          </a>

          <a
            href="https://www.instagram.com/goodspeedairport"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-12 h-12 bg-pink-600 text-white rounded-full hover:bg-pink-700 transition-colors"
            aria-label="Follow us on Instagram"
          >
            <svg
              className="w-6 h-6"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M12.017 0C8.396 0 7.929.01 6.71.048 5.493.085 4.73.204 4.058.388a5.918 5.918 0 0 0-2.134 1.39A5.918 5.918 0 0 0 .533 4.058C.204 4.73.085 5.493.048 6.71.01 7.929 0 8.396 0 12.017s.01 4.087.048 5.303c.037 1.218.156 1.98.34 2.653a5.918 5.918 0 0 0 1.39 2.134 5.918 5.918 0 0 0 2.134 1.39c.673.184 1.435.303 2.653.34 1.218.037 1.684.048 5.303.048s4.087-.01 5.303-.048c1.218-.037 1.98-.156 2.653-.34a5.918 5.918 0 0 0 2.134-1.39 5.918 5.918 0 0 0 1.39-2.134c.184-.673.303-1.435.34-2.653.037-1.218.048-1.684.048-5.303s-.01-4.087-.048-5.303c-.037-1.218-.156-1.98-.34-2.653a5.918 5.918 0 0 0-1.39-2.134A5.918 5.918 0 0 0 19.982.388C19.308.204 18.546.085 17.327.048 16.109.01 15.642 0 12.017 0zm0 2.164c3.204 0 3.584.012 4.85.07 1.366.062 2.633.336 3.608 1.311.975.975 1.249 2.242 1.311 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.336 2.633-1.311 3.608-.975.975-2.242 1.249-3.608 1.311-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.336-3.608-1.311-.975-.975-1.249-2.242-1.311-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.336-2.633 1.311-3.608.975-.975 2.242-1.249 3.608-1.311 1.266-.058 1.646-.07 4.85-.07z"
                clipRule="evenodd"
              />
              <path
                fillRule="evenodd"
                d="M12.017 5.838a6.179 6.179 0 1 0 0 12.358 6.179 6.179 0 0 0 0-12.358zM12.017 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"
                clipRule="evenodd"
              />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}